<ion-input
  class="search-input"
  placeholder="{{'__HOME_MULTI_SEARCH_RESOURCES_PLACEHOLDER__' | translate}}"
  [(ngModel)]="query"
  (ionInput)="handleSearchDebounced()"
  (ionFocus)="onFocus()"
  (ionBlur)="onBlur()"
>
</ion-input>

<div *ngIf="showResults && isFocused" class="break-line"></div>

<div class="search-results" *ngIf="showResults && isFocused">
  <div class="search-results-header">
    {{'__HOME_MULTI_SEARCH_RESOURCES_RESULTS__' | translate}} ({{results.length}})
  </div>
  <ion-list class="search-results-list" lines="none">
    <ion-item *ngFor="let result of results | slice : 0 : 10" class="search-results-item" (click)="searchItemClick(result)">
      {{ result.title }}
    </ion-item>
  </ion-list>
</div>
